import { render, staticRenderFns } from "./NewUserForm.vue?vue&type=template&id=b6b8d19c&scoped=true&"
import script from "./NewUserForm.vue?vue&type=script&lang=js&"
export * from "./NewUserForm.vue?vue&type=script&lang=js&"
import style0 from "./NewUserForm.vue?vue&type=style&index=0&id=b6b8d19c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b8d19c",
  null
  
)

export default component.exports